export default { sha: 'c2aea2047aea35fee42ebab2c1e6602f9edf2ca9', buildNumber: 'undefined' }
